import React from "react";
import "./festival.css";

const FestivalCard = ({ image, title, date, tithi, paksha, alt }) => {
  return (
    <div className="festival-card">
      <div className="festival-card-image">
        <img 
          src={image} 
          alt={alt || "Festival"} 
          loading="lazy"
        />
      </div>
      {(title || date || tithi || paksha) && (
        <div className="festival-card-content">
          {title && <h3 className="festival-title">{title}</h3>}
          {date && <p className="festival-date">{date}</p>}
          {tithi && <p className="festival-info">Tithi: {tithi}</p>}
          {paksha && <p className="festival-info">Paksha: {paksha}</p>}
        </div>
      )}
    </div>
  );
};

export default FestivalCard;